import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getUserTypes = createAsyncThunk('/getUserTypes',
  async () => {
    const response = await axios.get('/GetUserTypes');
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getUserTypeDetails = createAsyncThunk(
  '/getUserTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetUserTypeDetails/${id}`);
    return response.data;
  }
);

export const getMailGroups = createAsyncThunk(
  '/getMailGroups',
  async (id) => {
    const response = await axios.get(`/GetMailGroups`);
    return response.data;
  }
);
export const getSiriusUserTypeList = createAsyncThunk(
  '/getSiriusUserTypeList',
  async (id) => {
    const response = await axios.get(`/GetSiriusUserTypeList/${id}`);
    return response.data;
  }
);
export const getCaseOwnerWorkOrder = createAsyncThunk('/getCaseOwnerWorkOrder',
  async (ids) => {
    const response = await axios.get(`/getCaseOwnerWorkOrder/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}/${ids[4]}/${ids[5]}/${ids[6]}`);
    return response.data;
  });
  export const setCaseOwnerWorkOrder = createAsyncThunk('/setCaseOwnerWorkOrder', async (ids) => {
    const response = await axios.post(`/setCaseOwnerWorkOrder/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}`);
    return response.data;
  });
const userTypesSlice = createSlice({
  name: 'userTypes',
  initialState: {
    loading: false,
    error: '',
    SiriusUserType:[],
    userTypeDescriptions:[],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    IsService:true,
    IsCreate:true,
    IsUpdate:true,
    IsPotentialLiability:true,
    IsTaskType:true,
    CanSeeAllAgents:true,
    response: '',
    MailGroupId: 0,
    MailGroupList: [],
    SiriusUserTypes:[],
    CaseOwnerWorkOrder:[]
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.userTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeIsCheckedService(state, action) {
      state.IsService = action.payload;
    },
    changeIsCheckedCreate(state, action) {
      state.IsCreate = action.payload;
    },
    changeIsCheckedUpdate(state, action) {
      state.IsUpdate = action.payload;
    },
    changeIsCheckedPotentialLiability(state, action) {
      state.IsPotentialLiability = action.payload;
    },
    changeIsTaskType(state, action) {
      state.IsTaskType = action.payload;
    },
    changeCanSeeAllAgents(state, action) {
      state.CanSeeAllAgents = action.payload;
    },
    userTypeMailGroupUpdate(state,action){
      state.MailGroupId = action.payload
    }
  },
  extraReducers: {
    [getUserTypes.pending]: (state) => {
      state.loading = true;
    },
    [getUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getUserTypes.fulfilled]: (state, action) => {
      state.SiriusUserType= action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.userTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getUserTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getUserTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getUserTypeDetails.fulfilled]: (state, action) => {
      state.userTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getMailGroups.pending]: (state) => {
      state.loading = true;
    },
    [getMailGroups.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getMailGroups.fulfilled]: (state, action) => {
      state.MailGroupList = action.payload;
      state.loading = false;
    },
    [getSiriusUserTypeList.pending]: (state) => {
      state.loading = true;
    },
    [getSiriusUserTypeList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSiriusUserTypeList.fulfilled]: (state, action) => {
      state.SiriusUserTypes = action.payload;
      state.loading = false;
    },
    [getCaseOwnerWorkOrder.pending]: (state) => {
      state.loading = true;
    },
    [getCaseOwnerWorkOrder.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCaseOwnerWorkOrder.fulfilled]: (state, action) => {
      state.CaseOwnerWorkOrder = action.payload;
      state.loading = false;
    },
    [setCaseOwnerWorkOrder.pending]: (state) => {
      state.loading = true;
    },
    [setCaseOwnerWorkOrder.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setCaseOwnerWorkOrder.fulfilled]: (state, action) => {
      state.CaseOwnerWorkOrder = action.payload;
      state.loading = false;
    },
  }

});
export const userTypesActions = userTypesSlice.actions;

export default userTypesSlice;